import { useMutation } from 'react-query';

import { setSubProgramPreferenceProgressScurve as mutationFn } from 'api/endPoints/setSubProgramPreferenceProgressScurve';
import { QueryResponse } from 'api/queries/getPrefferedSPIMethod.query';

export const useMutationSetSubProgramPreferenceProgressScurve = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    subProgramId: number;
    option: QueryResponse;
}
